import { create } from "zustand";
import { Notification } from "../components/notifications/NotificationManager";

interface NotificationStore {
  notifications: Notification[];
  addNotification: (n: Omit<Notification, "id" | "timestamp"> & { id?: string; timestamp?: number }) => void;
  dismissNotification: (id: string) => void;
  clearNotifications: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],
  addNotification: (n) =>
    set((state) => ({
      notifications: [
        ...state.notifications,
        {
          ...n,
          id: n.id || Math.random().toString(36).slice(2),
          timestamp: n.timestamp || Date.now(),
        },
      ],
    })),
  dismissNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
  clearNotifications: () => set({ notifications: [] }),
})); 